import { type PropsWithChildren, type ComponentPropsWithoutRef } from 'react';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6 | 'p';

type HeadingElementType = 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type HeadingProps = PropsWithChildren<{
  level?: HeadingLevel;
}> & ComponentPropsWithoutRef<'p'>;

export const Heading = ( {
  children,
  level = 'p',
  ...props
}: HeadingProps ) => {
  const HeadingElement = level === 'p' ? 'p' : `h${ level }` as HeadingElementType;

  return (
    <HeadingElement { ...props }>
      {children}
    </HeadingElement>
  );
};

Heading.displayName = 'Heading';
